var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarDocuments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11.7499V2.24994C0.5 1.98472 0.605357 1.73037 0.792893 1.54283C0.98043 1.35529 1.23478 1.24994 1.5 1.24994H5.19C5.41843 1.24328 5.64226 1.31507 5.82421 1.45335C6.00615 1.59163 6.13525 1.78806 6.19 2.00994L6.5 3.24994H12.5C12.7652 3.24994 13.0196 3.35529 13.2071 3.54283C13.3946 3.73037 13.5 3.98472 13.5 4.24994V11.7499C13.5 12.0152 13.3946 12.2695 13.2071 12.457C13.0196 12.6446 12.7652 12.7499 12.5 12.7499H1.5C1.23478 12.7499 0.98043 12.6446 0.792893 12.457C0.605357 12.2695 0.5 12.0152 0.5 11.7499Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8H8.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarDocuments);
export default __webpack_public_path__ + "static/media/sidebar-documents.123f634ae5f968041e8289435f9c6d62.svg";
export { ForwardRef as ReactComponent };